export default {
  extension: {
    setting: {
      alertTitle: 'Title',
      alertType: 'Type',
      center: 'Center',
      closable: 'Closable',
      closeText: 'Text On Close Btn',
      collapseAccordion: 'Accordion Mode',
      collapseBorder: 'Outer Border',
      collapseItemBorder: 'Inner Border',
      collapseItemDisabled: 'Is Disabled',
      collapseItemExpand: 'Show',
      collapseItemIcon: 'Left Icon',
      collapseItemIsLink: 'Is Showw Link Icon',
      collapseItemLabel: 'Right Text',
      collapseItemLabelClass: 'Label Class Name',
      collapseItemLazyRender: 'Is Lazy Render Util Opened',
      collapseItemProperyDialogTitle: 'Collapse Item Property',
      collapseItemReadonly: 'Is Readonly',

      collapseItemSize: 'Title Size',
      collapseItemTitle: 'Name',
      collapseItemTitleClass: 'Title ClassName',
      collapseItemValue: 'Title',
      collapseItemValueClass: 'Value Class Name',
      description: 'Description',
      effect: 'Effect',
      showIcon: 'Show Icon',
    },

    widgetLabel: {
      alert: 'Alert',
      collapse: 'Collapse',
    },
  },
};
